// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goodslist-template1[data-v-7ed5f706] {\n  width: 10rem;\n}", ""]);
// Exports
module.exports = exports;
